import * as React from 'react'

function SvgCarFrontIconChecked(props) {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.0549 12H14.5C13.8398 12 13.2891 12.4199 13.0801 13.0098L11 19V27C11 27.2178 11.0703 27.4199 11.1895 27.585C11.3711 27.8359 11.668 28 12 28H13C13.5508 28 14 27.5498 14 27V26H26V27C26 27.5498 26.4492 28 27 28H28C28.5508 28 29 27.5498 29 27V20C28.3126 20 27.6432 19.9229 27 19.777V24H13V19H24.8728C23.9386 18.517 23.0998 17.8753 22.3921 17.1104H13.7695L14.8496 14H20.5121C20.287 13.3632 20.1316 12.6935 20.0549 12Z"
        fill="black"
      />
      <path
        d="M16.5605 22.5605C16.2793 22.8418 15.8984 23 15.5 23C15.2637 23 15.0352 22.9443 14.8301 22.8418C14.6875 22.7705 14.5547 22.6758 14.4395 22.5605C14.1582 22.2793 14 21.8975 14 21.5C14 21.1025 14.1582 20.7207 14.4395 20.4395C14.7207 20.1582 15.1016 20 15.5 20C15.7539 20 16 20.0645 16.2188 20.1836C16.3438 20.252 16.459 20.3379 16.5605 20.4395C16.8418 20.7207 17 21.1025 17 21.5C17 21.8975 16.8418 22.2793 16.5605 22.5605Z"
        fill="black"
      />
      <path
        d="M25.5605 22.5605C25.8418 22.2793 26 21.8975 26 21.5C26 21.1025 25.8418 20.7207 25.5605 20.4395C25.2793 20.1582 24.8984 20 24.5 20C24.248 20 24.002 20.0635 23.7852 20.1816C23.6582 20.25 23.543 20.3359 23.4395 20.4395C23.3008 20.5781 23.1914 20.7412 23.1172 20.9189C23.041 21.1016 23 21.2988 23 21.5C23 21.8975 23.1582 22.2793 23.4395 22.5605C23.6523 22.7734 23.9238 22.916 24.2148 22.9727C24.3086 22.9912 24.4043 23 24.5 23C24.8984 23 25.2793 22.8418 25.5605 22.5605Z"
        fill="black"
      />
      <path
        d="M28.0008 12.5998L32.3008 8.2998L33.7008 9.6998L28.0008 15.3998L24.3008 11.6998L25.7008 10.2998L28.0008 12.5998Z"
        fill="#2EC40B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 11C21 6.6 24.6 3 29 3C33.4 3 37 6.6 37 11C37 15.4 33.4 19 29 19C24.6 19 21 15.4 21 11ZM23 11C23 14.3 25.7 17 29 17C32.3 17 35 14.3 35 11C35 7.7 32.3 5 29 5C25.7 5 23 7.7 23 11Z"
        fill="#2EC40B"
      />
    </svg>
  )
}

export default SvgCarFrontIconChecked
